import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {Input} from "reactstrap";

class ReadOnlyMultiSelectClass extends Component {
    _getItems() {
        const items = this.props.items || [];
        const defaultItemDataMap = (item) => {
            return {name: item.name, id: item.id.toString()}
        };
        const itemDataMap = this.props.itemDataMap || defaultItemDataMap;
        return items.map(itemDataMap);
    }

    render() {
        const { t } = this.props;
        const items = this._getItems();

        if (items.length === 0) {
            return <p>{t('readonly_multiselect.no_items')}</p>;
        }

        return (
            <ul className="multi-select-list">
                {items.map(item => (
                    <li key={item.id}>
                        <label className="multi-select-item">
                            <Input type="checkbox"
                                   checked={true}
                                   readOnly={true}
                            />
                            <p className="multi-select-item-name">{item.name}</p>
                        </label>
                    </li>
                ))}
            </ul>
        );
    }
}

export const ReadOnlyMultiSelect = withTranslation()(ReadOnlyMultiSelectClass);
